import { ReactNode } from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

type FieldProps = {
  label: string;
  registration: UseFormRegisterReturn;
  error?: FieldError;
  placeholder?: string;
  type?: string;
  children?: ReactNode;
};

export function TextField({ label, registration, error, placeholder, type = "text" }: FieldProps) {
  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <Input type={type} placeholder={placeholder} {...registration} />
      {error && <p className="text-xs text-red-400">{error.message}</p>}
    </div>
  );
}

export function TextAreaField({ label, registration, error, placeholder }: FieldProps) {
  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <Textarea rows={4} placeholder={placeholder} {...registration} />
      {error && <p className="text-xs text-red-400">{error.message}</p>}
    </div>
  );
}

export function SecurityNote() {
  return (
    <div className="rounded border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-xs text-amber-100">
      Keypair inputs are encrypted in the browser for this operation. They are cleared after success and are not
      saved in admin history.
    </div>
  );
}
